import { render, staticRenderFns } from "./DocumentsUpload.template.vue?vue&type=template&id=59be0e5e&scoped=true&"
var script = {}
import style0 from "./DocumentsUpload.template.vue?vue&type=style&index=0&id=59be0e5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be0e5e",
  null
  
)

export default component.exports